import { BaseFetch } from "../main-model";
export default class ScoreModel extends BaseFetch {
  getScoreById = (data) =>
    this.authFetch({
      url: "score/getScoreById",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateScoreById = (data) =>
    this.authFetch({
      url: "score/updateScoreById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertScore = (data) =>
    this.authFetch({
      url: "score/insertScore",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteScoreById = (data) =>
    this.authFetch({
      url: "score/deleteScoreById",
      method: "POST",
      body: JSON.stringify(data),
    });
  getScoreActivityBy = (data) =>
    this.authFetch({
      url: "score/getScoreActivityBy",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateScoreActivityById = (data) =>
    this.authFetch({
      url: "score/updateScoreActivityById",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertScoreActivity = (data) =>
    this.authFetch({
      url: "score/insertScoreActivity",
      method: "POST",
      body: JSON.stringify(data),
    });
}
